import React, { useEffect, useState } from "react";
import { getInvoices } from "../../../services/invoice.services";

const InvoiceHeader = ({ handleNewInvoice }) => {
  const [invoices, setInvoices] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);

  // Calculate statistics
  const totalAmount = invoices.reduce(
    (sum, inv) => sum + parseFloat(inv.total_amount || 0),
    0
  );
  const paidCount = invoices.filter((inv) => inv.status === "Paid").length;
  const pendingCount = invoices.filter(
    (inv) => inv.status === "Pending"
  ).length;
  const overdueCount = invoices.filter(
    (inv) => inv.status === "Overdue"
  ).length;

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await getInvoices();
        setInvoices(response.data);
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };

    fetchInvoices();
  }, []);

  return (
    <div className="w-full">
      <HeaderCard
        onNewInvoice={handleNewInvoice}
        invoices={invoices}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        totalAmount={totalAmount}
        paidCount={paidCount}
        pendingCount={pendingCount}
        overdueCount={overdueCount}
      />
    </div>
  );
};

// Reusable Header Card Component with responsive design
const HeaderCard = ({
  onNewInvoice,
  invoices,
  isExpanded,
  setIsExpanded,
  totalAmount,
  paidCount,
  pendingCount,
  overdueCount,
}) => (
  <div className="bg-white border border-purple-500 rounded-lg shadow-md p-4 md:p-6 w-full">
    {/* Header Section with responsive flexbox */}
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-4 gap-4">
      <h2 className="text-xl font-bold text-gray-700">Invoice</h2>
      <button
        onClick={onNewInvoice}
        className="px-4 py-2 bg-purple-600 text-white font-medium rounded-md hover:bg-purple-700 transition w-full sm:w-auto"
      >
        + New Invoice
      </button>
    </div>

    {/* Collapse/Expand Toggle */}
    <div className="flex justify-end w-full mt-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="text-gray-500 text-sm flex items-center gap-1"
      >
        {isExpanded ? "Hide Stats" : "Show Stats"}
        <span>{isExpanded ? "▲" : "▼"}</span>
      </button>
    </div>

    {/* Metrics Section - Conditionally rendered */}
    {isExpanded && (
      <MetricsGrid
        invoiceCount={invoices.length}
        totalAmount={totalAmount}
        paidCount={paidCount}
        pendingCount={pendingCount}
        overdueCount={overdueCount}
      />
    )}
  </div>
);

// Reusable Metrics Grid Component with better responsiveness
const MetricsGrid = ({
  invoiceCount,
  totalAmount,
  paidCount,
  pendingCount,
  overdueCount,
}) => (
  <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    <MetricCard bgColor="bg-green-500" count={invoiceCount}>
      Total Invoices
    </MetricCard>
    <MetricCard bgColor="bg-yellow-500" count={pendingCount}>
      Pending Invoices
    </MetricCard>
    <MetricCard bgColor="bg-red-500" count={overdueCount}>
      Overdue Invoices
    </MetricCard>
    <MetricCard bgColor="bg-purple-500" count={paidCount}>
      Paid Invoices
    </MetricCard>
    {/* <MetricCard
      bgColor="bg-blue-500"
      count={`₹ ${totalAmount.toFixed(2)}`}
      className="sm:col-span-2 lg:col-span-1"
    >
      Total Amount
    </MetricCard> */}
  </div>
);

// Reusable Metric Card Component
const MetricCard = ({ bgColor, children, count, className = "" }) => (
  <div className={`${bgColor} p-4 rounded-md shadow-md ${className}`}>
    <h3 className="text-white font-semibold text-sm md:text-base">
      {children}
    </h3>
    {count !== undefined && (
      <p className="text-white text-lg font-bold mt-1">{count}</p>
    )}
  </div>
);

export default InvoiceHeader;
